module.exports = __webpack_public_path__ + "media/icons/copy-discount-code-icon-be4abcaa.svg";